export const messages = {
  supportedFiles: 'Supported files',
  fileType: 'File Type',
  fileExtension: 'File Extension',
  contactText:
    'If your file is among the supported files and you still experience problems with the upload please',
  contactLink: 'contact us',
  unsupportedFile: {
    title: 'Unsupported File Type',
    text: 'Uploaded file is not supported, please upload another file. To view the list of supported files <anchor>click here</anchor>.',
  },
  dragAndDrop: 'Drop file here',
  dragAndDropText: 'Drag and drop or click to upload',
  uploading: 'Uploading',
  fileTooLarge: {
    title: 'File Too Large',
    text: 'File ({{fileName}}) is too large. Max file size is 30mb.',
  },
  fileInstructions: 'File or scan of new documents.',
} as const
